import comp from "./Toastr";
export default comp;
